import ROUTES from '../routes';
import ProfitLoss from '../hoc/profit-loss/profit-loss';
import Sheet from '../hoc/profit-loss/sheet';
import FRS from '../hoc/profit-loss/frs';

const ProfitLossRoutes = {
  path: ROUTES.REPORTS_PROFIT_lOSS,
  element: <ProfitLoss />,
  children: [
    {
      path: ROUTES.REPORTS_PROFIT_lOSS_SHEET,
      element: <Sheet />,
    },
    {
      path: ROUTES.REPORTS_PROFIT_lOSS_FRS,
      element: <FRS />,
    },
  ],
};

export default ProfitLossRoutes;
